module.exports = __webpack_public_path__ + "static/media/rap.ce21ef19.mp3";